import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { axiosInt, API_CORE_URL } from '../../../utils';
import type { IBaseTableParams } from '../../../types';

export interface IModelInstanceFilterValuesParams extends IBaseTableParams {
  modelIds: string[];
  fieldPath: string;
  filters?: string;
  pathFilters?: string;
}

export interface IFilterValue {
  values: string[];
  type: string;
  hasNext: boolean;
  hasPrev: boolean;
}

export const FETCH_MODEL_INSTANCES_FILTER_VALUES_KEY =
  'fetchModelInstancesFilterValues';
export const fetchModelInstancesFilterValuesApi = async (
  params?: IModelInstanceFilterValuesParams
): Promise<IFilterValue> => {
  const response = await axiosInt.get(
    `${API_CORE_URL}/model-instances/filter-values`,
    {
      params,
    }
  );
  return response.data;
};

const useFetchModelInstancesFilterValues = ({
  params,
  options,
}: {
  params?: IModelInstanceFilterValuesParams;
  options?: Partial<UseQueryOptions<IFilterValue>>;
} = {}) => {
  const {
    data: filterValues,
    isLoading: isLoadingFilterValues,
    isFetching: isFetchingFilterValues,
    error: errorFetchingFilterValues,
  } = useQuery<any>({
    queryKey: [FETCH_MODEL_INSTANCES_FILTER_VALUES_KEY, params],
    queryFn: () => fetchModelInstancesFilterValuesApi(params),
    ...options,
  });

  return {
    filterValues,
    isLoadingFilterValues,
    isFetchingFilterValues,
    errorFetchingFilterValues,
  };
};

export default useFetchModelInstancesFilterValues;
